import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { MDBBtn } from 'mdb-react-ui-kit';
import errorImg from '../assets/error-404.svg'

const ErrorPage = () => {
    return (
      <Wrapper className='page-100'>
          <section>
              <img src={errorImg} className="img-fluid" alt="error-404" width="790"/>
              <h2 className='text-white display-4 mt-3 mb-5 font-weight-bold'>Desculpe, esta página não existe.</h2>
              <Link to="/"> 
                <MDBBtn rounded className="main-btn mb-5 px-5 py-3">Voltar à homepage</MDBBtn>
              </Link>
          </section>
      </Wrapper>
    )
  }
  
  const Wrapper = styled.main`
    margin-top: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  `
  
  export default ErrorPage
